import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "login-box" }
const _hoisted_2 = { class: "card card-outline card-primary" }
const _hoisted_3 = { class: "card-header text-center" }
const _hoisted_4 = { class: "card-body" }
const _hoisted_5 = { class: "row" }
const _hoisted_6 = { class: "col-12" }

export function render(_ctx, _cache) {
  const _component_router_link = _resolveComponent("router-link")
  const _component_app_input = _resolveComponent("app-input")
  const _component_app_button = _resolveComponent("app-button")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_router_link, {
          to: "/",
          class: "h1"
        }, {
          default: _withCtx(() => _cache[3] || (_cache[3] = [
            _createElementVNode("b", null, "HIAE", -1),
            _createTextVNode(" TRAUMA ")
          ])),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_4, [
        _cache[5] || (_cache[5] = _createElementVNode("p", { class: "login-box-msg" }, "Informe login e senha para entrar", -1)),
        _createElementVNode("form", {
          onSubmit: _cache[2] || (_cache[2] = _withModifiers((...args) => (_ctx.login && _ctx.login(...args)), ["prevent"]))
        }, [
          _createVNode(_component_app_input, {
            class: "mb-3",
            autocomplete: "off",
            modelValue: _ctx.accessKey,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => ((_ctx.accessKey) = $event)),
            placeholder: "Login"
          }, null, 8, ["modelValue"]),
          _createVNode(_component_app_input, {
            icon: "lock",
            class: "mb-3",
            type: "password",
            placeholder: "Senha",
            autocomplete: "off",
            modelValue: _ctx.secretKey,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => ((_ctx.secretKey) = $event))
          }, null, 8, ["modelValue"]),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createVNode(_component_app_button, {
                class: "btn-primary",
                type: "submit",
                block: "true",
                loading: _ctx.isAuthLoading
              }, {
                default: _withCtx(() => _cache[4] || (_cache[4] = [
                  _createTextVNode(" Entrar ")
                ])),
                _: 1
              }, 8, ["loading"])
            ])
          ])
        ], 32)
      ])
    ])
  ]))
}